import { render } from "./AdditInfo.vue?vue&type=template&id=1afddee4&scoped=true"
import script from "./AdditInfo.vue?vue&type=script&lang=js"
export * from "./AdditInfo.vue?vue&type=script&lang=js"

import "./AdditInfo.vue?vue&type=style&index=0&id=1afddee4&scoped=true&lang=css"

import exportComponent from "C:\\code\\kascenskaforvt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afddee4"]])

export default __exports__